'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _eventEmitter = require('./eventEmitter');

var _eventEmitter2 = _interopRequireDefault(_eventEmitter);

var _dataModel = require('./dataModel');

var _dataModel2 = _interopRequireDefault(_dataModel);

var _lodash = require('lodash.defaults');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.isempty');

var _lodash4 = _interopRequireDefault(_lodash3);

var _lodash5 = require('lodash.sortedindex');

var _lodash6 = _interopRequireDefault(_lodash5);

var _lodash7 = require('lodash.groupby');

var _lodash8 = _interopRequireDefault(_lodash7);

var _lodash9 = require('lodash.countby');

var _lodash10 = _interopRequireDefault(_lodash9);

var _lodash11 = require('lodash.sortby');

var _lodash12 = _interopRequireDefault(_lodash11);

var _lodash13 = require('lodash.reject');

var _lodash14 = _interopRequireDefault(_lodash13);

var _lodash15 = require('lodash.invoke');

var _lodash16 = _interopRequireDefault(_lodash15);

var _lodash17 = require('lodash.max');

var _lodash18 = _interopRequireDefault(_lodash17);

var _lodash19 = require('lodash.min');

var _lodash20 = _interopRequireDefault(_lodash19);

var _lodash21 = require('lodash.first');

var _lodash22 = _interopRequireDefault(_lodash21);

var _lodash23 = require('lodash.initial');

var _lodash24 = _interopRequireDefault(_lodash23);

var _lodash25 = require('lodash.rest');

var _lodash26 = _interopRequireDefault(_lodash25);

var _lodash27 = require('lodash.last');

var _lodash28 = _interopRequireDefault(_lodash27);

var _lodash29 = require('lodash.without');

var _lodash30 = _interopRequireDefault(_lodash29);

var _lodash31 = require('lodash.shuffle');

var _lodash32 = _interopRequireDefault(_lodash31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Backbone.Collection
var _class = function (_EventEmitter) {
    _inherits(_class, _EventEmitter);

    function _class(models) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this));

        var proto = Object.getPrototypeOf(_this),
            ctr = proto.constructor;

        _this.url = options.url || ctr.url;
        _this.model = options.model || ctr.model || _dataModel2.default;
        if (options.comparator !== void 0) {
            _this.comparator = options.comparator;
        }
        _this._reset();
        _this.initialize.call(_this, models, options);
        if (models) _this.reset(models, Object.assign({ silent: true }, options));
        return _this;
    }

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.


    _createClass(_class, [{
        key: 'initialize',
        value: function initialize() {}

        // The JSON representation of a Collection is an array of the
        // models' attributes.

    }, {
        key: 'toJSON',
        value: function toJSON(options) {
            return this.map(function (model) {
                return model.toJSON(options);
            });
        }

        // Proxy `Backbone.sync` by default.

    }, {
        key: 'sync',
        value: function sync() {}

        // Add a model, or list of models to the set.

    }, {
        key: 'add',
        value: function add(models) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return this.set(models, (0, _lodash2.default)(options, { add: true, merge: false, remove: false }));
        }

        // Remove a model, or a list of models from the set.

    }, {
        key: 'remove',
        value: function remove(models) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            models = models instanceof Array ? models.slice() : [models];

            var i = void 0,
                l = void 0,
                index = void 0,
                model = void 0;
            for (i = 0, l = models.length; i < l; i++) {
                model = this.get(models[i]);
                if (!model) continue;
                delete this._byId[model.id];
                delete this._byId[model.cid];
                index = this.indexOf(model);
                this.models.splice(index, 1);
                this.length--;
                if (!options.silent) {
                    options.index = index;
                    model.trigger('remove', model, this, options);
                }
                this._removeReference(model);
            }
            return this;
        }

        // Update a collection by `set`-ing a new list of models, adding new ones,
        // removing models that are no longer present, and merging models that
        // already exist in the collection, as necessary. Similar to **Model#set**,
        // the core operation for updating the data contained by the collection.

    }, {
        key: 'set',
        value: function set(models) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            options = (0, _lodash2.default)(options, { add: true, remove: true, merge: true });
            if (options.parse) models = this.parse(models, options);
            if (!(models instanceof Array)) models = models ? [models] : [];
            var i = void 0,
                l = void 0,
                model = void 0,
                existing = void 0,
                sort = void 0,
                at = options.at,
                sortable = this.comparator && !at && options.sort !== false,
                sortAttr = typeof this.comparator === 'string' ? this.comparator : null,
                toAdd = [],
                toRemove = [],
                modelMap = {};

            // Turn bare objects into model references, and prevent invalid models
            // from being added.
            for (i = 0, l = models.length; i < l; i++) {
                if (!(model = this._prepareModel(models[i], options))) continue;

                // If a duplicate is found, prevent it from being added and
                // optionally merge it into the existing model.
                if (existing = this.get(model)) {
                    if (options.remove) modelMap[existing.cid] = true;
                    if (options.merge) {
                        existing.set(model.attributes, options);
                        if (sortable && !sort && existing.hasChanged(sortAttr)) sort = true;
                    }

                    // This is a new model, push it to the `toAdd` list.
                } else if (options.add) {
                    toAdd.push(model);

                    // Listen to added models' events, and index models for lookup by
                    // `id` and by `cid`.
                    model.on('all', this._onModelEvent, this);
                    this._byId[model.cid] = model;
                    if (model.id !== undefined) this._byId[model.id] = model;
                }
            }

            // Remove nonexistent models if appropriate.
            if (options.remove) {
                for (i = 0, l = this.length; i < l; ++i) {
                    if (!modelMap[(model = this.models[i]).cid]) toRemove.push(model);
                }
                if (toRemove.length) this.remove(toRemove, options);
            }

            // See if sorting is needed, update `length` and splice in new models.
            if (toAdd.length) {
                if (sortable) sort = true;
                this.length += toAdd.length;
                if (at) {
                    Array.prototype.splice.apply(this.models, [at, 0].concat(toAdd));
                } else {
                    Array.prototype.push.apply(this.models, toAdd);
                }
            }

            // Silently sort the collection if appropriate.
            if (sort) this.sort({ silent: true });

            if (options.silent) return this;

            // Trigger `add` events.
            for (i = 0, l = toAdd.length; i < l; i++) {
                (model = toAdd[i]).trigger('add', model, this, options);
            }

            // Trigger `sort` if the collection was sorted.
            if (sort) this.trigger('sort', this, options);
            return this;
        }

        // When you have more items than you want to add or remove individually,
        // you can reset the entire set with a new list of models, without firing
        // any granular `add` or `remove` events. Fires `reset` when finished.
        // Useful for bulk operations and optimizations.

    }, {
        key: 'reset',
        value: function reset(models) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var i = 0,
                l = this.models.length;

            for (i; i < l; i++) {
                this._removeReference(this.models[i]);
            }
            options.previousModels = this.models;
            this._reset();
            this.add(models, Object.assign({ silent: true }, options));
            if (!options.silent) this.trigger('reset', this, options);
            return this;
        }

        // Add a model to the end of the collection.

    }, {
        key: 'push',
        value: function push(model, options) {
            model = this._prepareModel(model, options);
            this.add(model, Object.assign({ at: this.length }, options));
            return model;
        }

        // Remove a model from the end of the collection.

    }, {
        key: 'pop',
        value: function pop(options) {
            var model = this.at(this.length - 1);
            this.remove(model, options);
            return model;
        }

        // Add a model to the beginning of the collection.

    }, {
        key: 'unshift',
        value: function unshift(model, options) {
            model = this._prepareModel(model, options);
            this.add(model, Object.assign({ at: 0 }, options));
            return model;
        }

        // Remove a model from the beginning of the collection.

    }, {
        key: 'shift',
        value: function shift(options) {
            var model = this.at(0);
            this.remove(model, options);
            return model;
        }

        // Slice out a sub-array of models from the collection.

    }, {
        key: 'slice',
        value: function slice(begin, end) {
            return this.models.slice(begin, end);
        }

        // Get a model from the set by id.

    }, {
        key: 'get',
        value: function get(obj) {
            if (obj === null || typeof obj === 'undefined' || obj === '') return void 0;
            return this._byId[obj.id !== undefined ? obj.id : obj.cid || obj];
        }

        // Get the model at the given index.

    }, {
        key: 'at',
        value: function at(index) {
            return this.models[index];
        }

        // Return models with matching attributes. Useful for simple cases of
        // `filter`.

    }, {
        key: 'where',
        value: function where(attrs, first) {
            if ((0, _lodash4.default)(attrs)) return first ? void 0 : [];
            var key = void 0;

            return this[first ? 'find' : 'filter'](function (model) {
                for (key in attrs) {
                    if (attrs.hasOwnProperty(key)) {
                        if (attrs[key] !== model.get(key)) return false;
                    }
                }
                return true;
            });
        }

        // Return the first model with matching attributes. Useful for simple cases
        // of `find`.

    }, {
        key: 'findWhere',
        value: function findWhere(attrs) {
            return this.where(attrs, true);
        }

        // Force the collection to re-sort itself. You don't need to call this under
        // normal circumstances, as the set will maintain sort order as each item
        // is added.

    }, {
        key: 'sort',
        value: function sort() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (!this.comparator) throw new Error('Cannot sort a set without a comparator');

            // Run sort based on type of `comparator`.
            if (typeof this.comparator === 'string' || this.comparator.length === 1) {
                this.models = this.sortBy(this.comparator, this);
            } else {
                this.models.sort(this.comparator.bind(this));
            }

            if (!options.silent) this.trigger('sort', this, options);
            return this;
        }

        // Figure out the smallest index at which a model should be inserted so as
        // to maintain order.

    }, {
        key: 'sortedIndex',
        value: function sortedIndex(model, value, context) {
            value || (value = this.comparator);
            var iterator = typeof value === 'function' ? value : function (model) {
                return model.get(value);
            };
            return (0, _lodash6.default)(this.models, model, iterator, context);
        }

        // Pluck an attribute from each model in the collection.

    }, {
        key: 'pluck',
        value: function pluck(attr) {
            return this.models.map(function (model) {
                if (typeof model.get === 'function') {
                    return model.get(attr);
                } else {
                    return null;
                }
            });
        }

        // Fetch the default set of models for this collection, resetting the
        // collection when they arrive. If `reset: true` is passed, the response
        // data will be passed through the `reset` method instead of `set`.

    }, {
        key: 'fetch',
        value: function fetch(options) {
            options = options ? Object.assign({}, options) : {};
            if (options.parse === void 0) options.parse = true;
            var success = options.success,
                collection = this;

            options.success = function (resp) {
                var method = options.reset ? 'reset' : 'set';
                collection[method](resp, options);
                if (success) success(collection, resp, options);
                collection.trigger('sync', collection, resp, options);
            };
            this._wrapError(this, options);
            return this.sync('read', this, options);
        }

        // Create a new instance of a model in this collection. Add the model to the
        // collection immediately, unless `wait: true` is passed, in which case we
        // wait for the server to agree.

    }, {
        key: 'create',
        value: function create(model, options) {
            options = options ? Object.assign({}, options) : {};
            if (!(model = this._prepareModel(model, options))) return false;
            if (!options.wait) this.add(model, options);
            var collection = this,
                success = options.success;

            options.success = function (resp) {
                if (options.wait) collection.add(model, options);
                if (success) success(model, resp, options);
            };
            model.save(null, options);
            return model;
        }

        // **parse** converts a response into a list of models to be added to the
        // collection. The default implementation is just to pass it through.

    }, {
        key: 'parse',
        value: function parse(resp, options) {
            return resp;
        }

        // Create a new collection with an identical list of models as this one.

    }, {
        key: 'clone',
        value: function clone() {
            return new this.constructor(this.models);
        }

        // Private method to reset all internal state. Called when the collection
        // is first initialized or reset.

    }, {
        key: '_reset',
        value: function _reset() {
            this.length = 0;
            this.models = [];
            this._byId = {};
        }

        // Prepare a hash of attributes (or other model) to be added to this
        // collection.

    }, {
        key: '_prepareModel',
        value: function _prepareModel(attrs) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            if (attrs instanceof _dataModel2.default) {
                if (!attrs.collection) attrs.collection = this;
                return attrs;
            }
            options.collection = this;
            var model = new this.model(attrs, options);
            if (!model._validate(attrs, options)) {
                this.trigger('invalid', this, attrs, options);
                return false;
            }
            return model;
        }

        // Internal method to sever a model's ties to a collection.

    }, {
        key: '_removeReference',
        value: function _removeReference(model) {
            if (this === model.collection) delete model.collection;
            model.off('all', this._onModelEvent, this);
        }

        // Internal method called every time a model in the set fires an event.
        // Sets need to update their indexes when models change ids. All other
        // events simply proxy through. "add" and "remove" events that originate
        // in other collections are ignored.

    }, {
        key: '_onModelEvent',
        value: function _onModelEvent(event, model, collection, options) {
            var _trigger;

            if ((event === 'add' || event === 'remove') && collection !== this) return;
            if (event === 'destroy') this.remove(model, options);
            if (model && event === 'change:' + model.idAttribute) {
                delete this._byId[model.previous(model.idAttribute)];
                if (model.id !== undefined) this._byId[model.id] = model;
            }

            for (var _len = arguments.length, rest = Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
                rest[_key - 4] = arguments[_key];
            }

            (_trigger = this.trigger).call.apply(_trigger, [this, event, model, collection, options].concat(rest));
        }

        // Underscore methods that take a property name as an argument.

    }, {
        key: 'groupBy',
        value: function groupBy(value, context) {
            var iterator = typeof value === 'function' ? value : function (model) {
                return model.get(value);
            };
            return (0, _lodash8.default)(this.models, iterator, context);
        }
    }, {
        key: 'countBy',
        value: function countBy(value, context) {
            var iterator = typeof value === 'function' ? value : function (model) {
                return model.get(value);
            };
            return (0, _lodash10.default)(this.models, iterator, context);
        }
    }, {
        key: 'sortBy',
        value: function sortBy(value, context) {
            var iterator = typeof value === 'function' ? value : function (model) {
                return model.get(value);
            };
            return (0, _lodash12.default)(this.models, iterator, context);
        }
    }, {
        key: '_wrapError',
        value: function _wrapError(model, options) {
            var error = options.error;
            options.error = function (resp) {
                if (error) error(model, resp, options);
                model.trigger('error', model, resp, options);
            };
        }
    }, {
        key: 'forEach',
        value: function forEach() {
            var _models;

            return (_models = this.models).forEach.apply(_models, arguments);
        }
    }, {
        key: 'each',
        value: function each() {
            return this.forEach.apply(this, arguments);
        }
    }, {
        key: 'map',
        value: function map() {
            var _models2;

            return (_models2 = this.models).map.apply(_models2, arguments);
        }
    }, {
        key: 'collect',
        value: function collect() {
            return this.map.apply(this, arguments);
        }
    }, {
        key: 'reduce',
        value: function reduce() {
            var _models3;

            return (_models3 = this.models).reduce.apply(_models3, arguments);
        }
    }, {
        key: 'foldl',
        value: function foldl() {
            var _models4;

            return (_models4 = this.models).reduce.apply(_models4, arguments);
        }
    }, {
        key: 'inject',
        value: function inject() {
            return this.reduce.apply(this, arguments);
        }
    }, {
        key: 'reduceRight',
        value: function reduceRight() {
            var _models5;

            return (_models5 = this.models).reduceRight.apply(_models5, arguments);
        }
    }, {
        key: 'foldr',
        value: function foldr() {
            return this.reduceRight.apply(this, arguments);
        }
    }, {
        key: 'find',
        value: function find() {
            var _models6;

            return (_models6 = this.models).find.apply(_models6, arguments);
        }
    }, {
        key: 'detect',
        value: function detect() {
            return this.find.apply(this, arguments);
        }
    }, {
        key: 'filter',
        value: function filter() {
            var _models7;

            return (_models7 = this.models).filter.apply(_models7, arguments);
        }
    }, {
        key: 'select',
        value: function select() {
            return this.filter.apply(this, arguments);
        }
    }, {
        key: 'reject',
        value: function reject() {
            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }

            return _lodash14.default.apply(undefined, [this.models].concat(args));
        }
    }, {
        key: 'every',
        value: function every() {
            var _models8;

            return (_models8 = this.models).every.apply(_models8, arguments);
        }
    }, {
        key: 'all',
        value: function all() {
            return this.every.apply(this, arguments);
        }
    }, {
        key: 'some',
        value: function some() {
            var _models9;

            return (_models9 = this.models).some.apply(_models9, arguments);
        }
    }, {
        key: 'any',
        value: function any() {
            return this.some.apply(this, arguments);
        }
    }, {
        key: 'include',
        value: function include() {
            var _models10;

            return (_models10 = this.models).includes.apply(_models10, arguments);
        }
    }, {
        key: 'contains',
        value: function contains() {
            return this.include.apply(this, arguments);
        }
    }, {
        key: 'invoke',
        value: function invoke() {
            for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
            }

            return _lodash16.default.apply(undefined, [this.models].concat(args));
        }
    }, {
        key: 'max',
        value: function max() {
            for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                args[_key4] = arguments[_key4];
            }

            return _lodash18.default.apply(undefined, [this.models].concat(args));
        }
    }, {
        key: 'min',
        value: function min() {
            for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                args[_key5] = arguments[_key5];
            }

            return _lodash20.default.apply(undefined, [this.models].concat(args));
        }
    }, {
        key: 'toArray',
        value: function toArray() {
            return this.models;
        }
    }, {
        key: 'size',
        value: function size() {
            return this.models.length;
        }
    }, {
        key: 'first',
        value: function first() {
            for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
                args[_key6] = arguments[_key6];
            }

            return _lodash22.default.apply(undefined, [this.models].concat(args));
        }
    }, {
        key: 'head',
        value: function head() {
            return this.first.apply(this, arguments);
        }
    }, {
        key: 'take',
        value: function take() {
            return this.first.apply(this, arguments);
        }
    }, {
        key: 'initial',
        value: function initial() {
            for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
                args[_key7] = arguments[_key7];
            }

            return _lodash24.default.apply(undefined, [this.models].concat(args));
        }
    }, {
        key: 'rest',
        value: function rest() {
            for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
                args[_key8] = arguments[_key8];
            }

            return _lodash26.default.apply(undefined, [this.models].concat(args));
        }
    }, {
        key: 'tail',
        value: function tail() {
            return this.rest.apply(this, arguments);
        }
    }, {
        key: 'drop',
        value: function drop() {
            return this.rest.apply(this, arguments);
        }
    }, {
        key: 'last',
        value: function last() {
            for (var _len9 = arguments.length, args = Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
                args[_key9] = arguments[_key9];
            }

            return _lodash28.default.apply(undefined, [this.models].concat(args));
        }
    }, {
        key: 'without',
        value: function without() {
            for (var _len10 = arguments.length, args = Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
                args[_key10] = arguments[_key10];
            }

            return _lodash30.default.apply(undefined, [this.models].concat(args));
        }
    }, {
        key: 'indexOf',
        value: function indexOf() {
            var _models11;

            return (_models11 = this.models).indexOf.apply(_models11, arguments);
        }
    }, {
        key: 'shuffle',
        value: function shuffle() {
            for (var _len11 = arguments.length, args = Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
                args[_key11] = arguments[_key11];
            }

            return _lodash32.default.apply(undefined, [this.models].concat(args));
        }
    }, {
        key: 'lastIndexOf',
        value: function lastIndexOf() {
            var _models12;

            return (_models12 = this.models).lastIndexOf.apply(_models12, arguments);
        }
    }, {
        key: 'isEmpty',
        value: function isEmpty() {
            return this.models.length === 0;
        }
    }]);

    return _class;
}(_eventEmitter2.default);

exports.default = _class;